import axios from 'axios';
import config from 'config';
import {
  cognitoAuthRequestInterceptor,
  dataResponseInterceptor,
  unauthenticatedRequestInterceptor,
} from 'domains/api/interceptors';

export const baseAPIClient = axios.create({
  baseURL: config.get('apiBaseUrl'),
  headers: {
    'Content-type': 'application/json',
  },
});

baseAPIClient.interceptors.request.use(...cognitoAuthRequestInterceptor);

baseAPIClient.interceptors.response.use(...dataResponseInterceptor);

export const baseAPIClientAnonymous = axios.create({
  baseURL: config.get('apiBaseUrl'),
  headers: {
    'Content-type': 'application/json',
  },
});

baseAPIClientAnonymous.interceptors.request.use(...unauthenticatedRequestInterceptor);
baseAPIClientAnonymous.interceptors.response.use(...dataResponseInterceptor);
